<div class="delete-content">
<p>Möchten Sie diesen Mitarbeiter wirklich entfernen?</p>

@if (employee()) {
  <p class="employee-description">{{ employee()?.email }}</p>
}

<form #form="ngForm" (ngSubmit)="onSubmit()">
  <ui-form-submit [data]="itemSubmit"></ui-form-submit>
</form>
</div>
